var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessHomeFlame(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14.1172,
    height: 18,
    viewBox: "0 0 14.1172 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trending-content--lit-flame-torch-trending"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12336 0.16173C5.30055 0.0558879 5.50308 0 5.70948 0C5.90238 0 6.09192 0.0488186 6.26054 0.141612C11.3862 2.52301 14.2886 7.46792 14.1094 11.6022C14.033 13.3398 13.4108 14.9475 12.2056 16.122C11.0004 17.2965 9.26879 17.9832 7.07645 17.9874C6.19581 18.0417 5.31309 17.9207 4.47944 17.6313C3.63917 17.3397 2.86571 16.883 2.2046 16.2879C1.54348 15.6929 1.00805 14.9716 0.629829 14.1666C0.251597 13.3617 0.0382071 12.4891 0.00222 11.6004L0.00183422 11.5908C-0.0244201 10.5624 0.231604 9.54652 0.741981 8.65336C1.25235 7.7602 1.99765 7.02392 2.89694 6.52446C3.05497 6.4367 3.24263 6.41951 3.41397 6.47712C3.5853 6.53473 3.72445 6.66181 3.79735 6.82722C4.11072 7.53834 4.54959 8.18522 5.09128 8.73768C5.72691 7.90844 6.01935 6.83703 6.01071 5.65986C6.00041 4.25762 5.55993 2.75559 4.82261 1.47663C4.7019 1.27517 4.65782 1.0368 4.69868 0.805272C4.74019 0.57 4.86655 0.358118 5.0538 0.20975C5.07592 0.192235 5.09915 0.176194 5.12336 0.16173Z",
    fill: "#006F41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessHomeFlame);
export default __webpack_public_path__ + "static/media/business_home_flame.7377c4d26596f5f1714016f330dcc6ea.svg";
export { ForwardRef as ReactComponent };